import { render, staticRenderFns } from "./YDFM.vue?vue&type=template&id=65447893&scoped=true&"
import script from "./YDFM.vue?vue&type=script&lang=js&"
export * from "./YDFM.vue?vue&type=script&lang=js&"
import style0 from "./YDFM.vue?vue&type=style&index=0&id=65447893&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65447893",
  null
  
)

export default component.exports